import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pwa-ios-bar',
  templateUrl: './pwa-ios-bar.component.html',
  styleUrls: ['./pwa-ios-bar.component.scss'],
})
export class PwaIosBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
